import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { LocateProductionTask } from '../../Gantt/hooks';

type KanbanIntersectionProps = {
  className?: string;
  elements: number;
  queueId: number;
};

const KANBAN_TASK_INITIAL_WIDTH = 250;

/**
 * Render only queues which are in ViewPort
 */
export const KanbanIntersection = ({
  children,
  className,
  elements,
  queueId,
}: PropsWithChildren<KanbanIntersectionProps>) => {
  const [height, setHeight] = useState(elements * KANBAN_TASK_INITIAL_WIDTH);

  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        setIsVisible(entry.isIntersecting);
      });
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [containerRef]);

  useEffect(() => {
    if (isVisible && containerRef.current?.clientHeight) {
      setHeight(containerRef.current?.clientHeight);
    }
  }, [isVisible]);

  return (
    <div
      className={className}
      ref={containerRef}
      style={{ height: !isVisible ? `${height}px` : undefined }}
      {...LocateProductionTask.addQueueSelector(queueId)}
    >
      {isVisible ? children : null}
    </div>
  );
};
